import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { makeStyles } from '@mui/styles';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import useFeatures from '../../customContextProviders/FeatureContext';

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function TripMoreMenu({ tripData, handleClicks, sx }) {
  const classes = useStyles();
  const ref = useRef(null);
  const feature = useFeatures();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton data-testid="trip-more-menu" sx={sx} ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        sx={{
          '& .MuiListItemText-root > .MuiTypography-root': {
            color: '#000',
            fontWeight: 600,
            fontStyle: 'normal'
          },
          pl: 3
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {feature?.trip?.editDriverDetail && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('edit_driver', tripData);
            }}
            sx={{ color: 'text.secondary' }}
            className={classes.menuItem}
          >
            <ListItemText
              primary="Edit Driver Details"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        )}
        {feature?.trip?.tripStatus && (
          <>
            {tripData?.trip?.status === 'scheduled' && (
              <MenuItem
                onClick={() => {
                  setIsOpen(false);
                  handleClicks('start_trip', tripData);
                }}
                sx={{ color: 'text.secondary' }}
                className={classes.menuItem}
              >
                <ListItemText primary="Start Trip" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            )}

            {tripData?.trip?.status === 'started' && (
              <MenuItem
                onClick={() => {
                  setIsOpen(false);
                  handleClicks('end_trip', tripData);
                }}
                sx={{ color: 'text.secondary' }}
                className={classes.menuItem}
              >
                <ListItemText primary="End Trip" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            )}
          </>
        )}

        {/* <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('report_issue', tripData);
          }}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemText primary="Report Issue" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('export_trip', tripData);
          }}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemText primary="Export Trip" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> */}

        {feature?.trip?.deleteTrip && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('delete_trip', tripData);
            }}
            sx={{ color: 'text.secondary' }}
            className={classes.menuItem}
          >
            <ListItemText primary="Delete Trip" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
